import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

const queryfunction = (fields: []) => {
  const query = gql`
    query getIndividualNetworkForPerticularAccountID {
      getIndividualNetworkForPerticularAccountID {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};
//

const PrivateNetwork = () => {
  const [isLoading, setIsLoading] = useState(true);
  const Key = "Private_Network";
  const [fetchMenuMaster, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([]), {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [loadingState, setLoading] = useState(true);
  const [formdata, setformdata] = useState([]);

  // Throw an error if the request is not fetched
  //Custom hook to fetch table data based on dynamic column selection.
  const { loading } = useFetchTableData(queryfunction, fetchMenuMaster, setIsLoading, Key);
  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  // Map the request data
  useEffect(() => {
    setLoading(true);
    let arr = data?.getIndividualNetworkForParticularAccountID?.map((e) => {
      let obj = { ...e };
      delete obj.__typename;

      if (obj?.createdAt) {
        obj.createdAt = IsoToDateTime(obj?.createdAt);
      }
      if (obj?.updatedAt) {
        obj.updatedAt = IsoToDateTime(obj?.updatedAt);
      }
      return obj;
    });
    setLoading(false);
    setformdata(arr);
  }, [data, isLoading]);

  return (
    <div>
      <HeaderDiv title="Private Network" />
      {loadingState || isLoading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {(queryLoading || loading) && <div className="loader-line-div" />}
          <LoadTable title={Key} data={formdata} loading={isLoading} error={error} selectedRows={[]} />
        </>
      )}
    </div>
  );
};

export default PrivateNetwork;
